var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-wrapper", {
    attrs: { "popup-name": "order-status" },
    on: {
      closePopup: function ($event) {
        _vm.resetPopup(), _vm.deleteStorageData()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _c("h2", { staticClass: "popup__title" }, [
              _vm._v("\n      Статус заказа\n    "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function (scope) {
          return [
            _vm.checkStep !== 3
              ? [
                  _c("div", { staticClass: "universal-popup" }, [
                    _c("div", { staticClass: "universal-popup__inputs" }, [
                      _c("div", { staticClass: "universal-popup__section" }, [
                        _c("label", { staticClass: "form__input-container" }, [
                          _c("span", { staticClass: "form__input-label" }, [
                            _vm._v("Номер заказа / e-mail"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.orderNumOrEmail,
                                expression: "form.orderNumOrEmail",
                              },
                            ],
                            ref: "numOrEmailElem",
                            class: [
                              "form__input-input",
                              { _error: _vm.numOrEmailError.isShow },
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "Введите e-mail или номер заказа",
                            },
                            domProps: { value: _vm.form.orderNumOrEmail },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.sendFirstResponse.apply(
                                  null,
                                  arguments
                                )
                              },
                              focus: function () {
                                return (_vm.numOrEmailError.isShow = false)
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form,
                                  "orderNumOrEmail",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "form__input-error" }, [
                            _vm._v(_vm._s(_vm.numOrEmailError.text)),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.checkStep === 2
                      ? _c("div", { staticClass: "universal-popup__inputs" }, [
                          _c(
                            "div",
                            { staticClass: "universal-popup__section" },
                            [
                              _c(
                                "label",
                                { staticClass: "form__input-container" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "form__input-label" },
                                    [
                                      _vm._v(
                                        "Письмо с кодом подтверждения отправлено на " +
                                          _vm._s(_vm.hiddenEmail)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.confirmCode,
                                        expression: "form.confirmCode",
                                      },
                                    ],
                                    class: [
                                      "form__input-input",
                                      { _error: _vm.confirmInputError.isShow },
                                    ],
                                    attrs: {
                                      type: "text",
                                      placeholder: "Введите код",
                                    },
                                    domProps: { value: _vm.form.confirmCode },
                                    on: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.secondStepClickHandler.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "confirmCode",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "form__input-error" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.confirmInputError.text)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "form__checkbox-container" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.willAuth,
                                    expression: "form.willAuth",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  "data-required": "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.form.willAuth)
                                    ? _vm._i(_vm.form.willAuth, null) > -1
                                    : _vm.form.willAuth,
                                },
                                on: {
                                  click: scope.changeReloadStatus,
                                  change: function ($event) {
                                    var $$a = _vm.form.willAuth,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form,
                                            "willAuth",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form,
                                            "willAuth",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form, "willAuth", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "form__checkbox-body",
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: [
                                    "form__checkbox-agree",
                                    { checked: _vm.form.willAuth },
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n              Авторизоваться\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "universal-popup__buttons" },
                      [
                        _vm.recaptchaToken &&
                        !_vm.isCaptchaDisabled &&
                        _vm.checkStep === 1
                          ? _c("vue-recaptcha", {
                              ref: "recaptcha",
                              staticClass: "recaptcha",
                              attrs: {
                                size: "invisible",
                                sitekey: _vm.recaptchaToken,
                              },
                              on: {
                                verify: function (resp) {
                                  return _vm.onRecaptchaVerified(resp)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkStep === 1
                          ? _c(
                              "button",
                              {
                                staticClass: "_btn submit-button",
                                on: { click: _vm.sendFirstResponse },
                              },
                              [
                                _c("span"),
                                _vm._v(" "),
                                _c("p", [_vm._v("Узнать статус")]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkStep === 2
                          ? _c(
                              "button",
                              {
                                staticClass: "_btn submit-button",
                                on: { click: _vm.secondStepClickHandler },
                              },
                              [
                                _c("span"),
                                _vm._v(" "),
                                _c("p", [_vm._v("Далее")]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showEmptyOrderListWarning
                          ? _c("p", { staticClass: "_error" }, [
                              _vm._v(
                                "\n            Нет активных заказов\n          "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              : _vm._l(_vm.ordersList, function (item, index) {
                  return _c("orderBlock", {
                    key: "order-numer-" + (index + 1),
                    staticClass: "order-item",
                    attrs: {
                      "order-title": item.number,
                      "order-date": item.dateCreated,
                      "order-status": item.status,
                      "send-status": item.sendStatus,
                    },
                    on: { sendOnMail: _vm.sendMailHandler },
                  })
                }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }